export const ACCOUNT_ROLES = {
  owner: "owner",
  member: "member",
  executiveCaller: "executive_caller",
  concierge: "concierge",
}

export function selectAccountRole(profile) {
  return profile?.role || ACCOUNT_ROLES.owner
}

export function isAccountOwner(profile) {
  // Require an explicit role. Missing role must NOT default to owner — otherwise
  // cold-start profile fetches omit X-Account-Owner-Id and undo account switches.
  return profile?.role === ACCOUNT_ROLES.owner
}

export function isExecutiveCaller(profile) {
  return (
    selectAccountRole(profile) === ACCOUNT_ROLES.executiveCaller ||
    profile?.is_onebase_staff
  )
}

export function isConcierge(profile) {
  return (
    selectAccountRole(profile) === ACCOUNT_ROLES.concierge ||
    Boolean(profile?.is_concierge)
  )
}

/** Texting-only employee: the backend refuses everything outside the SMS inbox. */
export function isSmsOnly(profile) {
  return Boolean(profile?.is_sms_only)
}

export function isTeamMember(profile) {
  return selectAccountRole(profile) === ACCOUNT_ROLES.member
}

/** Lead Targeting for Campaign — owner/member surfaces only, not concierge operators. */
export function canAccessLeadTargeting(profile) {
  return !isConcierge(profile)
}

/** Campaign settings tab — account owner and assigned concierge. */
export function canAccessCampaignTab(profile) {
  return isAccountOwner(profile) || isConcierge(profile)
}

/** Power Dialer — parent/owner account and assigned concierge. */
export function canUsePowerDialer(profile) {
  return isAccountOwner(profile) || isConcierge(profile)
}

/**
 * Owner-only surfaces (billing, team, integrations, office settings).
 * Matches backend user_can_access_billing / user_can_manage_* guards.
 */
export function canAccessOwnerAccountSettings(profile) {
  return isAccountOwner(profile)
}

/** Buy more MLS checkout — parent account owner only (billing IsAccountOwner). */
export function canPurchaseMls(profile) {
  return isAccountOwner(profile)
}

export function usesAccountOwnerHeader(profile) {
  return (
    isTeamMember(profile) ||
    selectAccountRole(profile) === ACCOUNT_ROLES.executiveCaller ||
    selectAccountRole(profile) === ACCOUNT_ROLES.concierge ||
    Boolean(profile?.is_onebase_staff) ||
    Boolean(profile?.is_concierge)
  )
}
